define(["require", "exports", "@drklein/locale-formatter", "hypo_bvo/Drklein/Shared/AgentService", "jquery", "jquery-countto"], function (require, exports, locale_formatter_1, AgentService_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    $(function () {
        var queryParam = {};
        var hypoport = window.hypoport;
        var produktsparte = "Gesamt";
        var produktsparteSchemaOrgName = "Baufinanzierung, Versicherung, Ratenkredit";
        if (hypoport && hypoport.produktsparteSeitenbaum) {
            produktsparte = hypoport.produktsparteSeitenbaum;
        }
        var kundenBewertungLinkText = "Alle Kundenbewertungen im Überblick";
        if (produktsparte !== "Gesamt") {
            queryParam = {
                platformProductGroupId: produktsparte.toUpperCase()
            };
            kundenBewertungLinkText = "Alle Kundenbewertungen für " + produktsparte + " im Überblick";
            produktsparteSchemaOrgName = produktsparte;
        }
        var $kundenbewertungsteaserList = $(".kundenbewertungsteaserStandalone");
        var $serviceRatingSchemaOrgTemplate = $kundenbewertungsteaserList.find("#serviceRatingSchemaOrgTemplate");
        var anzahlBewertungen = $kundenbewertungsteaserList.find(".kundenbewertungsteaserStandalone_anzahlBewertungen");
        var kundenbewertungNote = $kundenbewertungsteaserList.find(".kundenbewertungNote_noteState");
        var kundenEmpfehlung = $kundenbewertungsteaserList.find(".kundenbewertungsteaserDetails_empfehlungQuote");
        var kundenBewertungLink = $kundenbewertungsteaserList.find(".kundenbewertungsteaserStandalone_kundenbewertungsseiteLink");
        if ($kundenbewertungsteaserList.length) {
            setKundenbewertungsteaserByProduktsparte();
        }
        function setKundenbewertungsteaserByProduktsparte() {
            $.get((0, AgentService_1.getRatingPath)(), queryParam).then(function (rating) {
                if (rating.numberOfRatings > 0) {
                    setRatingValues(Number(rating.numberOfRatings), Number(rating.averageRating), Number(rating.recommendationPercent));
                    setSchemaOrgData(produktsparteSchemaOrgName, produktsparte, rating.numberOfRatings, rating.averageRating);
                    $kundenbewertungsteaserList.find(".kundenbewertungsteaserStandalone_noKundenbewertungsteaserDataFallback").slideUp("fast");
                    $kundenbewertungsteaserList.find(".kundenbewertungsteaserStandalone_dynamicallyEnhancedContent").slideDown("slow");
                }
            });
        }
        function setRatingValues(nrOfRatings, averageRating, recommendationPercent) {
            $(kundenBewertungLink).each(function (index, element) {
                $(element).text(kundenBewertungLinkText);
            });
            $(anzahlBewertungen).each(function (index, element) {
                animateFormattedValue($(element), nrOfRatings, (0, locale_formatter_1.numberWithThousandsSeparator)(nrOfRatings, 0).toString());
            });
            $(kundenbewertungNote).each(function (index, element) {
                var formattedValue = (0, locale_formatter_1.percentage)(averageRating).toString();
                var formattedValueWithoutSymbol = formattedValue.substring(0, formattedValue.length - 2);
                animateFormattedValue($(element), averageRating, formattedValueWithoutSymbol);
            });
            $('.kundenbewertungsteaserDetails_kundenbewertung .starsRating_stars.starsRating_stars--is-foreground').each(function (index, element) {
                $(element).css('width', (averageRating * 20) + '%');
            });
            $(kundenEmpfehlung).each(function (index, element) {
                animateFormattedValue($(element), recommendationPercent, (0, locale_formatter_1.percentage)(recommendationPercent).toString());
            });
        }
        function animateFormattedValue($element, number, numberFormatted) {
            $element.countTo({
                from: 0,
                to: number,
                speed: 1000,
                formatter: function () {
                    return numberFormatted;
                },
            });
        }
        function setSchemaOrgData(produktsparteSchemaOrgName, produktsparte, anzahl, bewertung) {
            var kundenbewertungSchemaOrgData = {
                name: produktsparteSchemaOrgName,
                serviceId: "#service" + produktsparte,
                anzahl: anzahl,
                bewertung: bewertung,
            };
            //Temporarily not in use -> OVIT-8968: Remove Schema.org-tag
            //$kundenbewertungsteaserList.append(HypoportMustache.renderSchemaOrg($serviceRatingSchemaOrgTemplate, kundenbewertungSchemaOrgData));
        }
    });
});
